export enum NotificationTypes {
  ORDER = 'message_center_order_status',
  BONUS = 'message_center_personal_bonuses',
  MESSAGE = 'message_center_personal_messages',
  PROMOTION = 'message_center_promotion',
  PROMOCODE = 'message_center_personal_promocodes',
}

export enum COLORS {
  BLUE = '#1a82cb',
  RED = '#f34744',
}

export const ICONS = {
  [NotificationTypes.ORDER]: { color: COLORS.BLUE, name: 'orderIcon' },
  [NotificationTypes.BONUS]: { color: COLORS.BLUE, name: 'bonusIcon' },
  [NotificationTypes.MESSAGE]: { color: COLORS.BLUE, name: 'messageIcon' },
  [NotificationTypes.PROMOTION]: { color: COLORS.RED, name: 'promotionIcon' },
  [NotificationTypes.PROMOCODE]: { color: COLORS.RED, name: 'promocodeIcon' },
};
